<template>
    <header>
        <div class="container header">
            <div id="nav" class="col">
                <router-link class="logo" to="/" tag="div">
                    <img style="width:125px;height: 72px;" src="/static/img/logo.png" />
                </router-link>
                <div class="nav-item">
                    <ul style="position:relative">
                        <li @mouseover="addClass($event)" @mouseleave="rmClass($event)" v-for="(item,index) in navItems"
                            :key="index" @click="toLink(item.link, $event)">
                            {{ item.text }}
                            <div v-if="index == 2" class="dropdown-menu">
                                <div class="dropdown-menu-item" @click="jump('/ac1')">4G打印机</div>
                                <div class="dropdown-menu-item" @click="jump('/ac2')">WiFi+USB</div>
                                <div class="dropdown-menu-item" @click="jump('/ac3')">蓝牙+USB</div>
                                <div v-if="index == 2" class="dropdown-menu-item"></div>
                            </div>
                        </li>
                        <li @click="gotoBackend($event)">
                            <div class="navbar-button">管理后台</div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="cndns-right" v-if="showService">
            <div class="cndns-right-meau meau-sev">
                <a href="javascript:" class="cndns-right-btn">
                    <span class="demo-icon"></span>
                    <p>
                        在线
                        <br />客服
                    </p>
                </a>
                <div class="cndns-right-box">
                    <div class="box-border">
                        <div class="clearfix sev-t">
                            <span class="demo-icon">
                                <i class="fa fa-comments-o"></i>
                            </span>
                            <p>
                                在线客服
                                <i>服务时间：周一至周日 09:00～20:00</i>
                            </p>
                        </div>
                        <div class="clearfix sev-b">
                            <h4>选择下列服务马上在线沟通：</h4>
                            <ul id="zixunUl">
                                <li>
                                    <a href="tencent://message/?uin=9892500&amp;Site=&amp;Menu=yes">销售经理</a>
                                </li>
                                <li>
                                    <a href="tencent://message/?uin=9892500&amp;Site=&amp;Menu=yes">市场合作</a>
                                </li>
                                <li>
                                    <a href="tencent://message/?uin=9892500&amp;Site=&amp;Menu=yes">技术支持</a>
                                </li>
                                <li>
                                    <a href="tencent://message/?uin=9892500&amp;Site=&amp;Menu=yes">售后客服</a>
                                </li>
                            </ul>
                        </div>
                        <span class="arrow-right"></span>
                    </div>
                </div>
            </div>
            <div class="cndns-right-meau meau-contact">
                <a href="javascript:" class="cndns-right-btn">
                    <span class="demo-icon t2">
                        <img src="/static/img/t2.png" />
                    </span>
                    <p>
                        客服
                        <br />热线
                    </p>
                </a>
                <div class="cndns-right-box">
                    <div class="box-border">
                        <div class="clearfix sev-t">
                            <p>
                                13600093009
                                <br />
                                <i>服务时间：周一至周日 09:00～20:00</i>
                            </p>
                        </div>
                        <span class="arrow-right"></span>
                    </div>
                </div>
            </div>
            <div class="cndns-right-meau meau-code">
                <a href="javascript:" class="cndns-right-btn">
                    <span class="demo-icon t3">
                        <img src="/static/img/t3.png" />
                    </span>
                    <p>
                        关注
                        <br />微信
                    </p>
                </a>
                <div class="cndns-right-box">
                    <div class="box-border clearfix">
                        <div class="sev-t">
                            <img src="/static/img/wx.jpg" />
                            <i>关注微信公众号</i>
                        </div>
                        <span class="arrow-right"></span>
                    </div>
                </div>
            </div>
            <div class="cndns-right-meau meau-top" id="top-back" style="display: block;">
                <a href="javascript:" class="cndns-right-btn backtop" @click="topBack()">
                    <span style="line-height:35px;">^</span>
                    <i style="margin-top:-10px;">顶部</i>
                </a>
            </div>
        </div>
    </header>
</template>

<script>
const navItems = [{
    text: '官网首页',
    link: '/'
}, {
    text: '应用场景',
    link: '/aps'
}, {
    text: '产品简介',
    link: '/brief'
}, {
    text: '开放平台',
    link: '/open'
}, {
    text: '加盟合作',
    link: '/cooperation'
}, {
    text: '联系我们',
    link: '/contact'
}];
import router from '../router';

export default {
    name: 'topHeader',
    data() {
        return {
            navItems: navItems,
            navIn: 'nav-out',
            menu: ['dropdown-menu', 'dropdown-menu-item'],
            showService: true
        }
    },
    watch: {
        $route(to) {
            this.toggleShowService(to.path);
        }
    },
    mounted() {
        this.toggleShowService(this.$route.path);
        // 1. 当前路径
        const path = this.$route.path
        let index = navItems.findIndex(item => item.link == path)
        const $event = document.querySelector('.nav-item li:nth-child(' + (index + 1) + ')')
        // 2. 添加样式
        if ($event && $event.classList) {
            $event.classList.add('selected');
        }

        //置顶图标显示
        $('#top-back').hide()
        $(window).scroll(function () {
            if ($(this).scrollTop() > 350) {
                $("#top-back").fadeIn();
            } else {
                $("#top-back").fadeOut();
            }
        })
        //置顶事件
        function topBack() {
            $('body,html').animate({ scrollTop: 0 }, 300);
        }
    },
    methods: {
        toggleShowService(path) {
            if (path.indexOf("/login") == 0 || path.indexOf("/backend") == 0) {
                this.showService = false;
            } else {
                this.showService = true;
            }
        },
        topBack() {
            document.body.scrollIntoView()
        },
        jump(path) {
            [].forEach.call(document.getElementsByTagName('li'), function (item) { item.className = '' });
            let $event = document.querySelector('.nav-item li:nth-child(3)');
            // 2. 添加样式
            $event.classList.add('selected');
            this.$router.push(path);
        },
        toLink(link, $event) {
            const className = $event.target.className
            if (this.menu.includes(className.trim())) {
                return
            }

            [].forEach.call(document.getElementsByTagName('li'), function (item) { item.className = '' });
            if (link == '/login' || link == '/backend/index') {
                router.push(link || '/');
            } else {
                router.push(link || '/');
                $event.target.className = 'selected';
            }

        },
        gotoBackend(e) {
            let cacheDeveloper = sessionStorage.getItem("loginInfo");
            if (cacheDeveloper) {
                this.toLink("/backend/index", e);
            } else {
                this.toLink("/login", e);
            }
        },
        addClass($event) {
            const className = $event.target.className
            if (this.menu.includes(className.trim())) {
                return
            }

            if (!className.match(new RegExp('(\\s|^)' + 'selected' + '(\\s|$)'))) {
                $event.target.className = ' ';
            }
            if (!className.match(new RegExp('(\\s|^)' + 'nav-in' + '(\\s|$)'))) {
                $event.target.className += ' ' + 'nav-in';
            }
        },
        rmClass($event) {
            const className = $event.target.className
            if (this.menu.includes(className.trim())) {
                return
            }
            if (!className.match(new RegExp('(\\s|^)' + 'selected' + '(\\s|$)'))) {
                $event.target.className = ' ';
            }
            if (!className.match(new RegExp('(\\s|^)' + 'nav-out' + '(\\s|$)'))) {
                $event.target.className += ' ' + 'nav-out';
            }
        }
    }
}
</script>
<style>
.container {
    position: relative;
    width: 100% !important;
}

.cndns-right {
    position: fixed;
    right: 1px;
    top: 50%;
    margin-top: -100px;
    z-index: 100;
}

.cndns-right-meau {
    position: relative;
}

.cndns-right-btn {
    width: 48px;
    height: 48px;
    border: 1px solid #ddd;
    text-align: center;
    border-radius: 5px;
    display: block;
    margin-bottom: 6px;
    position: relative;
    background-color: #fff;
}

.cndns-right-btn span {
    color: #848484;
    font-size: 26px;
}

.t2 {
    line-height: 42px !important;
}

.t3 {
    line-height: 42px !important;
}

.backtop:hover {
    border-color: #ff6700;
}

.cndns-right-btn sup {
    display: block;
    min-width: 24px;
    height: 24px;
    text-align: center;
    line-height: 24px;
    color: #fff;
    border-radius: 50%;
    background-color: #ff6700;
    position: absolute;
    left: -12px;
    top: -12px;
}

.cndns-right-btn p {
    color: #ff6700;
    font-size: 14px;
    line-height: 18px;
    margin-top: 8px;
    display: none;
}

.cndns-right-meau:hover .cndns-right-btn span {
    display: none;
}

.cndns-right-meau:hover .cndns-right-btn p {
    display: block;
    line-height: 16px;
    margin-top: 4px;
}

.meau-car .cndns-right-btn {
    border-color: #ff6700;
    margin-bottom: 20px;
}

.meau-car.cndns-right-meau:hover .cndns-right-btn {
    background-color: #ff6700;
}

.meau-car.cndns-right-meau:hover .cndns-right-btn span {
    color: #fff;
    display: block;
}

.meau-car .cndns-right-btn span {
    color: #ff6700;
}

.meau-sev .cndns-right-btn {
    border-color: #ff6700;
    background: url(../../static/img/t1.gif) no-repeat #ff6700 center;
}

.meau-sev .cndns-right-btn p {
    color: #fff;
}

.meau-sev .cndns-right-btn span {
    color: #fff;
}

.meau-top .cndns-right-btn i.fa {
    font-size: 30px;
}

.meau-top .cndns-right-btn i {
    font-size: 12px;
    display: block;
    margin-top: -3px;
}

.meau-top .cndns-right-btn i {
    display: block;
    color: #999;
    font-style: normal;
}

.meau-top.cndns-right-meau:hover .cndns-right-btn {
    background-color: #ff6700;
}

.meau-top.cndns-right-meau:hover .cndns-right-btn span {
    display: block;
    color: #fff;
}

.meau-top.cndns-right-meau:hover .cndns-right-btn i {
    color: #fff;
}

.cndns-right-box {
    position: absolute;
    top: -15px;
    right: 48px;
    padding-right: 25px;
    display: none;
}

.cndns-right-box .box-border {
    border-radius: 10px;
    border: 1px solid #ccc;
    border-top: 4px solid #ff6700;
    padding: 20px;
    background-color: #fff;
    -webkit-box-shadow: 0 3px 8px rgba(0, 0, 0, 0.15);
    -moz-box-shadow: 0 3px 8px rgba(0, 0, 0, 0.15);
    box-shadow: 0 3px 8px rgba(0, 0, 0, 0.15);
    position: relative;
}

.cndns-right-box .box-border .arrow-right {
    display: block;
    width: 13px;
    height: 16px;
    /* // background: url(../images/arrow.png) no-repeat; */
    position: absolute;
    right: -13px;
    top: 26px;
}

.cndns-right-box .box-border .sev-t span {
    font-size: 42px;
    float: left;
    display: block;
    line-height: 56px;
    margin-right: 20px;
    color: #d3d3d3;
}

.cndns-right-box .box-border .sev-t p {
    float: left;
    color: #ff6700;
    font-size: 24px;
    line-height: 28px;
    width: 100%;
}

.cndns-right-box .box-border .sev-t p i {
    display: block;
    font-size: 14px;
    color: #aaa;
    font-style: normal;
}

.cndns-right-box .box-border .sev-b {
    border-top: 1px solid #e4e4e4;
}

.cndns-right-box .box-border .sev-b h4 {
    color: #666;
    font-size: 14px;
    font-weight: normal;
    text-align: left;
    padding-left: 35px;
}

.cndns-right-box .box-border .sev-b li {
    float: left;
    width: 33.33333%;
}

.cndns-right-box .box-border .sev-b li a {
    display: inline-block;
    color: #999;
    font-size: 13px;
    padding-left: 43px;
    background: url(../../static/img/q1.gif) no-repeat left 3px;
    line-height: 36px;
}

.cndns-right-box .box-border .sev-b li a:hover {
    color: #ff6700;
}

.meau-sev .cndns-right-box .box-border {
    width: 430px;
}

.meau-contact .cndns-right-box .box-border {
    width: 338px;
}

.cndns-right-meau:hover .cndns-right-box {
    display: block;
}

.meau-code .cndns-right-box {
    top: inherit;
    bottom: -35px;
}

.meau-code .cndns-right-box .box-border {
    width: 156px;
    text-align: center;
    border-top: 1px solid #ccc;
}

.meau-code .cndns-right-box .box-border i {
    display: block;
    color: #f66e06;
    font-style: normal;
    font-size: 16px;
    line-height: 16px;
}

.meau-code .cndns-right-box .box-border .arrow-right {
    top: inherit;
    bottom: 50px;
}

.meau-code .cndns-right-box .box-border img {
    width: 100%;
}

.meau-sev .cndns-right-btn .demo-icon {
    display: none;
}

.meau-sev:hover .cndns-right-btn {
    background: #ff6700;
}

.meau-zs .cndns-right-btn {
    background-color: #ff6700;
    color: #fff;
    margin-top: 80px;
    border-color: #ff6700;
}

.meau-zs .cndns-right-btn span {
    color: #fff;
}

.meau-zs .cndns-right-btn p {
    color: #fff;
}

a {
    text-decoration: none;
}

a:focus,
a:hover {
    color: #ff6700;
    text-decoration: none;
    -webkit-transition: all 0.2s ease;
    -o-transition: all 0.2s ease;
    transition: all 0.2s ease;
}

.clearfix:after,
.clearfix:before {
    display: table;
    content: " ";
}

.clearfix:after {
    clear: both;
}
</style>
<style scoped lang='scss'>
header {
    width: 100%;
    height: 60px;
    background: rgba(0, 0, 0, 0.6);
    position: fixed;
    z-index: 9;
}

.header {
    padding-left: 120px;
    padding-right: 120px;
}

li:nth-child(3):hover .dropdown-menu {
    display: block;
}

.dropdown-menu {
    display: none;
    min-width: 100px;
    text-align: center;
    background: white;
    left: -15px;
    top: 60px;
    font-size: 12px;
    color: #ff6700 !important;
}

.dropdown-menu-item {
    height: 30px;
    line-height: 30px;
}

.dropdown-menu-item:nth-last-child(1) {
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 8px solid white;
    position: absolute;
    left: 45px;
    top: -5px;
}

.dropdown-menu-item:hover {
    opacity: 0.8;
    font-size: 16px;
    color: #ff6700 !important;
}

#nav {
    width: 100%;
    height: 100%;
}

.logo {
    width: 125px;
    height: 72px;
    position: absolute;
    top: 0;
    cursor: pointer;
    border-top: solid 6px #ff6700;
}

.nav-item {
    height: 100%;

    ul {
        list-style: none;
        margin: 0;
        padding: 0;
        text-align: right;
        height: 100%;
        line-height: 60px;
    }
}

li {
    height: 100%;
    position: relative;
    display: inline-block;
    margin-left: 40px;
    cursor: pointer;
    font-size: 14px;
    color: #fff;
    opacity: 0.8;
}

.navbar-button {
    background-color: #ff6700;
    height: 30px;
    display: flex;
    align-items: center;
    padding: 10px 25px;
    border-radius: 5px;
}

.selected {
    color: #ff6700;
}

@mixin nav-in {
    @-webkit-keyframes navin {
        0% {
            color: #fff;
        }

        100% {
            color: #ff6700;
        }
    }

    @-moz-keyframes navin {
        0% {
            color: #fff;
        }

        100% {
            color: #ff6700;
        }
    }

    @-ms-keyframes navin {
        0% {
            color: #fff;
        }

        100% {
            color: #ff6700;
        }
    }

    @-o-keyframes navin {
        0% {
            color: #fff;
        }

        100% {
            color: #ff6700;
        }
    }

    @keyframes navin {
        0% {
            color: #fff;
        }

        100% {
            color: #ff6700;
        }
    }
}

.nav-in {
    @include nav-in;
    -webkit-animation: navin 0.5s 0s ease both;
    -moz-animation: navin 0.5s 0s ease both;
    -ms-animation: navin 0.5s 0s ease both;
    -o-animation: navin 0.5s 0s ease both;
    animation: navin 0.5s 0s ease both;
}
</style>





 


// WEBPACK FOOTER //
// topHeader.vue?3ce242ec